import React, {ChangeEvent, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useFormikContext} from 'formik';

import FormikLikeInput from '../../formikFileds/likeInput';
import {FromikType} from '../../../pages/farm/advertisementRegisteration/types';
import useGetSearchStoresByNumber from '../../../services/hookService/getSearchStoresByNumber/useGetSearchStoresByNumber';
import {getLatLng} from '../../../utilities/helper/getLatLng';
import {addAddress} from '../../../store/redux/saleAgentsSelectedLocation';
import {RootState} from '../../../store/redux';

const CustomDropDown = ({
  onChange,
  storeGuid,
  setStoreGuid,
  cardGuid,
}: {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  storeGuid: string;
  cardGuid?: string;
  setStoreGuid: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const {values, setFieldValue} = useFormikContext<FromikType>();
  const {storeData, refetchStoreList} = useGetSearchStoresByNumber(
    values?.phone_number as string,
  );

  const dispatch = useDispatch();
  const saleAgentLocation = useSelector(
    (state: RootState) => state.saleAgentsLocation,
  );

  const [openSuggestion, setOpenSuggestion] = useState(false);


  useEffect(() => {
    if (values?.phone_number?.length === 12) {
      refetchStoreList();
    }
  }, [values.phone_number]);

  useEffect(() => {
    values?.phone_number && setOpenSuggestion(true);
  }, [values?.phone_number]);

  return (
    <div className="relative">
      <FormikLikeInput
        name="phone_number"
        label="شماره تلفن همراه فروشگاه *"
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          onChange(e);
          setStoreGuid('');
        }}
      />
      {storeData &&
        !cardGuid &&
        saleAgentLocation.location?.length === 0 &&
        openSuggestion && (
          <div className="flex flex-col absolute top-full w-full bg-white p-2 z-10 shadow-lg ">
            <div className="flex justify-between items-center">
              <div
                className="flex items-center gap-2"
                onClick={() => {
                  setFieldValue('name', storeData.name);
                  setFieldValue('address', storeData.store.address);
                  setStoreGuid(storeData.store.guid);
                  setOpenSuggestion(false);
                  dispatch(
                    addAddress({
                      location: getLatLng(storeData?.store.location as string),
                      name: ((storeData?.store?.state as string) +
                        ' , ' +
                        storeData?.store.city) as string,
                    }),
                  );
                }}
              >
                <img
                  src={storeData.store.logo || ''}
                  alt="logo"
                  className="w-10 h-10 rounded-full"
                />
                <span>{storeData.store.title}</span>
              </div>
              <i
                className="icon-nameClose-remove"
                onClick={() => {
                  setOpenSuggestion(false);
                }}
              />
            </div>
          </div>
        )}
    </div>
  );
};

export default CustomDropDown;
